import { useEffect, useState } from "react";
import SimpleInput from "../../components/simpleInput/SimpleInput";
import SmallSelectPlaceholder from "../../components/SmallSelectPlaceholder/SmallSelectPlaceholder";
import Button from "../../components/button/Button";
import { Cities, Provinces, RegisterStep2 } from "../../auth/Index";
import BirthDate from "../../components/birthDate/BirthDate";
import moment from "jalali-moment";
import FormLayout from "../../components/layout/FormLayout";
import SectionCard from "../../components/layout/SectionCard";
import { LocationIcon } from "../../components/layout/MaterialIcons";
import DownloadAppDrawer from "../../components/drawer/DownloadAppDrawer";

export default function Address() {
  const [checkProvince, setCheckProvince] = useState(false);
  const [checkCity, setCheckCity] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [bgButton, setBgButton] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [refCode, setRefCode] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [city, setCity] = useState([]);
  const [chosenMariage, setChosenMariage] = useState("");
  const [selectMariage, setSelectMariage] = useState(false);
  const [selectphysicalCondition, setSelectPhysicalCondition] = useState(false);
  const [chosenPhysicalCondition, setChosenPhysicalCondition] = useState("");
  const [certificate, setCertificate] = useState("");

  const marriage = [
    { value: "مجرد", key: 0 },
    { value: "متاهل", key: 1 },
  ];
  const physicalCondition = [
    { value: "سالم", key: 0 },
    { value: "ناشنوا یا کم شنوا", key: 1 },
    { value: "محدودیت حرکتی", key: 2 },
  ];

  useEffect(() => {
    Provinces().then((res) => {
      setProvinces(res.data);
    });
  }, []);

  useEffect(() => {
    const key = selectedProvince;
    if (key > 0) {
      Cities(key).then((res) => {
        setCity(res.data);
      });
      setSelectedCity("");
      setCheckCity(false);
    }
  }, [selectedProvince]);

  const isValid =
    checkProvince === true &&
    checkCity === true &&
    certificate !== "" &&
    selectMariage === true &&
    selectphysicalCondition === true;

  useEffect(() => {
    if (isValid) {
      const data = {
        province: selectedProvince,
        city: selectedCity,
        isMarried: chosenMariage === 1,
        drivingLicDate: moment(certificate.toDate())
          .local("fa")
          .format("YYYY-MM-DD"),
        physicalCondition: chosenPhysicalCondition,
        address: "",
        postCode: "",
        refCode: refCode || null,
      };
      RegisterStep2(data)
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("token", res.data.token);
            setBgButton(true);
          }
        })
        .catch((err) => {
          console.log(err);
          setBgButton(false);
        });
    } else {
      setBgButton(false);
    }
  }, [
    isValid,
    selectedProvince,
    selectedCity,
    chosenMariage,
    chosenPhysicalCondition,
    certificate,
    refCode,
  ]);

  const handleSubmit = () => {
    if (bgButton) {
      setShowDrawer(true);
    }
  };

  return (
    <FormLayout
      footer={
        <Button
          title="ثبت"
          bgButton={bgButton}
          handleClick={handleSubmit}
        />
      }
    >
      <SectionCard
        icon={<LocationIcon />}
        iconBg="bg-[#22C55E]"
        title="اطلاعات محل سکونت"
        subtitle="استان و شهر محل سکونت خود را انتخاب کنید"
      >
        <div className="w-full flex gap-3">
          <div className="w-1/2">
            <div className="mb-2 flex justify-start items-center text-medium font-IRANSansBold">
              استان<span className="text-scabRed mr-1">*</span>
            </div>
            <SmallSelectPlaceholder
              items={provinces}
              setSelectItem={setCheckProvince}
              chosen={selectedProvince}
              setChosen={setSelectedProvince}
              fullWidth
            />
          </div>
          <div className="w-1/2">
            <div className="mb-2 flex justify-start items-center text-medium font-IRANSansBold">
              شهر<span className="text-scabRed mr-1">*</span>
            </div>
            <SmallSelectPlaceholder
              items={city}
              setSelectItem={setCheckCity}
              chosen={selectedCity}
              setChosen={setSelectedCity}
              fullWidth
            />
          </div>
        </div>
      </SectionCard>

      <SectionCard title="اطلاعات تکمیلی">
        <BirthDate
          title="تاریخ انقضا گواهینامه"
          required
          setDateOfBirth={setCertificate}
          dateOfBirth={certificate}
        />
        <div className="w-full flex gap-3 mb-4">
          <div className="w-1/2">
            <div className="mb-2 flex justify-start items-center text-medium font-IRANSansBold">
              وضعیت تأهل<span className="text-scabRed mr-1">*</span>
            </div>
            <SmallSelectPlaceholder
              items={marriage}
              setSelectItem={setSelectMariage}
              chosen={chosenMariage}
              setChosen={setChosenMariage}
              fullWidth
            />
          </div>
          <div className="w-1/2">
            <div className="mb-2 flex justify-start items-center text-medium font-IRANSansBold">
              وضعیت جسمانی<span className="text-scabRed mr-1">*</span>
            </div>
            <SmallSelectPlaceholder
              items={physicalCondition}
              setSelectItem={setSelectPhysicalCondition}
              chosen={chosenPhysicalCondition}
              setChosen={setChosenPhysicalCondition}
              fullWidth
            />
          </div>
        </div>
        <SimpleInput
          title="کد معرف پیمانکار (اختیاری)"
          setInputValue={setRefCode}
          inputValue={refCode.replace(/[^a-zA-Z0-9 ]/g, "").slice(0, 6)}
          placeholder=""
          valueType="text"
        />
      </SectionCard>
      <DownloadAppDrawer open={showDrawer} />
    </FormLayout>
  );
}
